const colors = {
  primary3: '#1E293B',
  black: '#222222',
  red2: '#FA362B',
  defaultBorder: '#F1F3F6',
  border1: 'rgba(222,226,230,0.8)',
  defaultTypo: '#1E293B',
  subTitle: '#5E656E',
  subTitle2: '#8C939A',
  subTitle3: '#8c929a',
  greyHover: '#F6F8FB',

  btnDisabledText: '#ACB3BA',
  btnDisabledStar: '#d5dbde',
  btnStar: '#FFA534',
  btnDisabledBg: '#F6F8FB',
  btnBlackText: 'white',
  btnBlackBg: 'black',
  slate200: '#E2E8F0',
  slate400: '#97A4B6',
  slate500: '#64748B',
  slate700: '#354256',
  slate800: '#1E293B',
};

export default colors;
